/**
 * Read-only audit of credits a user consumed by publishing. Mirrors the
 * PaymentsTab table styling. Empty/loading/error are handled by the caller.
 */
import type { PublishTransactionRow } from '../types';
import { EmptyState } from './EmptyState';

export function PublishHistoryTable({ rows }: { rows: PublishTransactionRow[] }) {
  if (rows.length === 0) {
    return (
      <EmptyState
        title="No publish history"
        hint="This user has not consumed any publish credits yet."
      />
    );
  }

  return (
    <div className="glass-panel rounded-xl overflow-hidden overflow-x-auto">
      <table className="w-full text-left text-sm">
        <thead className="bg-surface-container-low text-[10px] uppercase tracking-widest text-on-surface-variant">
          <tr>
            <th className="px-3 py-2">Date</th>
            <th className="px-3 py-2">Invitation</th>
            <th className="px-3 py-2">Credits used</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id} className="border-t border-border-subtle">
              <td className="px-3 py-2 text-xs">{new Date(r.createdAt).toLocaleString('en-IN')}</td>
              <td className="px-3 py-2 text-xs font-mono break-all">{r.invitationId}</td>
              <td className="px-3 py-2 text-xs">{r.creditsConsumed}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
